import React, { Component, createContext, useContext, useEffect, useState } from "react";
import Brique from "../img/brique.png";
import Tuile from "../img/tuile.png";
import Carreaux from "../img/carreaux.png";
import Chaise from "../img/chaise.png";
import PorteRideau from "../img/porte_rideau.png";
import Pavet from "../img/pavet.png";
import Table from "../img/table.png";
import { auth } from "../firebase";

export const DataContext = createContext();

export class DataProvider extends Component {
  state = {
    products: [
      {
        _id: 1,
        imgSrc: Brique,
        imgAlt: "Brique",
        title: "Brique lego",
        mesure: "ECOBRIKA 15*10*12",
        descTitle: "Brique lego-ecobrika",
        description:
          "Optez pour des briques résistant aux chocs, étanche et facile à mettre en place tout en minimisant l'utilisation des ciments avec une durée de vie de 60 ans.",
        dimension: "15*",
        prix: 500,
        count: 1,
      },
      {
        _id: 2,
        imgSrc: Tuile,
        imgAlt: "Tuile",
        title: "Tuile",
        mesure: "ECOKAPI 20*29",
        descTitle: "Tuile-ecokapila",
        description:
          "Des tuiles étanche et résistant aux chocs présentant une durée de vie plus de 60 ans avec un épaisseur de 2 cm.",
        dimension: "20*29",
        prix: 2500,
        count: 1,
      },
      {
        _id: 3,
        imgSrc: Carreaux,
        imgAlt: "Carreaux",
        title: "Carreaux",
        mesure: "ECOCAX 15*15",
        descTitle: "Carreaux-ecokaro",
        description:
          "Des mini-carreaux murales peuvent être également utilisés dans les douches, avec un épaisseur de 2 cm. C'est étanche et résistant aux chocs.",
        dimension: "15*15",
        prix: 500,
        count: 1,
      },
      {
        _id: 4,
        imgSrc: Chaise,
        imgAlt: "Chaise",
        title: "Chaise",
        mesure: "ECOSEZA Enfant",
        descTitle: "Chaise pliable-ecoseza",
        description:
          "Chaise à base de plastique avec une composition de 40% de plastique, idéale pour les enfants. Cette chaise supporte bien les charges.",
        dimension: "Enfant",
        prix: 30000,
        count: 1,
      },
      {
        _id: 5,
        imgSrc: PorteRideau,
        imgAlt: "Porte Rideau",
        title: "Porte Rideau",
        mesure: "ECOTRINGLE diamètre 2 cm",
        descTitle: "Triangle rideau-ecotringle",
        description: "Triangles pour rideaux, possèdant un diamètre de 2cm.",
        dimension: "2 cm",
        prix: 700,
        count: 1,
      },
      {
        _id: 6,
        imgSrc: Pavet,
        imgAlt: "Pavet",
        title: "Pavet",
        mesure: "ECOPAVE 15*15 épaisseur 4 cm",
        descTitle: "Pave-ecopave",
        description:
          "Pavé avec un épaisseur de 4 cm peut être utilisé dans les parkings des voitures ou à l'éxterieur des maisons.",
        dimension: "15*15 épaisseur 4 cm",
        prix: 500,
        count: 1,
      },
      {
        _id: 7,
        imgSrc: Table,
        imgAlt: "Table",
        title: "Table",
        mesure: "ECOTABLE 80*60 pliable",
        descTitle: "Table pliable-ecotable",
        description:
          "Table pliable à base de déchets plastiques.La table presente une bonne résistance et une bonne durabilité.",
        dimension: "80*60 pliable",
        prix: 45000,
        count: 1,
      },
    ],
    cart: [],
    total: 0,
    disabledButtons: {},
  };

  clearCart = () => {
    this.setState({ cart: [], total: 0, disabledButtons: {} });
  };

  addCart = (id) => {
    const { products, cart, disabledButtons } = this.state;
    const check = cart.every((item) => {
      return item._id !== id;
    });
    if (check) {
      const data = products.filter((product) => {
        return product._id === id;
      });
      this.setState({ cart: [...cart, ...data] });
    } else {
    }
    this.setState({ disabledButtons: { ...disabledButtons, [id]: true } });
  };

  reduction = (id) => {
    const { cart } = this.state;
    cart.forEach((item) => {
      if (item._id === id) {
        item.count === 1 ? (item.count = 1) : (item.count -= 1);
      }
    });
    this.setState({ cart: cart });
    this.getTotal();
  };

  increase = (id) => {
    const { cart } = this.state;
    cart.forEach((item) => {
      if (item._id === id) {
        item.count += 1;
      }
    });
    this.setState({ cart: cart });
    this.getTotal();
  };

  removeProduct = (id) => {
    const { cart } = this.state;
    cart.forEach((item, index) => {
      if (item._id === id) {
        cart.splice(index, 1);
      }
    });
    this.setState({ cart: cart });
    this.getTotal();
  };

  getTotal = () => {
    const { cart } = this.state;
    const res = cart.reduce((prev, item) => {
      return prev + ((item.prix * 90) / 100).toFixed(2) * item.count;
    }, 0);
    this.setState({ total: res });
  };

  initializeDisabledButtons = (cart) => {
    const disabledButtons = {};
    cart.forEach((item) => {
      disabledButtons[item._id] = true;
    });
    this.setState({ disabledButtons });
  };

  componentDidUpdate() {
    localStorage.setItem("dataCart", JSON.stringify(this.state.cart));
    localStorage.setItem("dataTotal", JSON.stringify(this.state.total));
    localStorage.setItem(
      "disabledButtons",
      JSON.stringify(this.state.disabledButtons)
    );
  }

  componentDidMount() {
    const dataCart = JSON.parse(localStorage.getItem("dataCart"));
    if (dataCart !== null) {
      this.setState({ cart: dataCart }, () => {
        this.getTotal();
        this.initializeDisabledButtons(dataCart);
      });
    }
    const dataTotal = JSON.parse(localStorage.getItem("dataTotal"));
    if (dataTotal !== null) {
      this.setState({ total: dataTotal });
    }
    const disabledButtons = JSON.parse(localStorage.getItem("disabledButtons"));
    if (disabledButtons !== null) {
      this.setState({ disabledButtons });
    }
  }

  render() {
    const { products, cart, total, disabledButtons } = this.state;
    const { addCart, reduction, increase, removeProduct, getTotal, clearCart } = this;
    return (
      <DataContext.Provider
        value={{
          products,
          addCart,
          cart,
          reduction,
          increase,
          removeProduct,
          total,
          getTotal,
          clearCart,
          disabledButtons,
        }}
      >
        {this.props.children}
      </DataContext.Provider>
    );
  }
}

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    setIsAuthenticated(false);
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, currentUser, setCurrentUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
